import {DetailPanel, DetailKvTable} from '../../../../components/detailLayout';
import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {handleValidation} from "../serviceUtils";
import {changeNextContentStatus} from "../../../../api/contentStatus/contentStatusService";
import {ContentCategory, ContentStatus} from "../../../../constant/CodeSpecNum";
import {changeStatusNumericValue} from "../../../../redux/slice/contentSlice";
import Th_title from "../../../../components/Th_title";
import TextAreaBasic from "../../../../components/input/TextAreaBasic";
import TextAreaUpdateBasic from "../../../../components/input/TextAreaUpdateBasic";
import {
    updateFeedbackDone,
    updateServiceRequestForFeedback
} from "../../../../api/serviceRequest/ServiceRequestService";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {RatedStart, ServiceStarRating} from "./ServiceStarRating";
import {changeRefreshContentStatus} from "../../../../redux/slice/statusSlice";
import {useTranslation} from "react-i18next";
import "./serviceRequestFeedback.css";

function FeedbackToolbar({children}) {
    return <div className="service-feedback-toolbar">{children}</div>;
}

function FeedbackActions({children}) {
    return <div className="service-feedback-toolbar__actions">{children}</div>;
}

const ServiceRequestFeedback = ({serviceRequest, initialData}) => {
    const [feedbackData, setFeedbackData] = useState(initialData);

    const {t} = useTranslation();

    const statusNumericValue = useSelector(state => state.content.statusNumericValue);
    const dispatch = useDispatch();

    const handleChangeNextStatus = async () => {
        const data = {...feedbackData, modification: true};
        if (!handleValidation(serviceRequest.feedbackRating, "만족도를 저장해주세요.")) return;
        if (window.confirm(t(`changeNextStep`))) {
            const serviceResponse = await updateFeedbackDone(data);
            if (serviceResponse && serviceResponse.status === 200) {
                const response = await changeNextContentStatus({
                    contentId: feedbackData.id,
                    contentCategory: ContentCategory.SERVICE_REQUEST
                });
                if (response && response.status === 200) {
                    dispatch(changeStatusNumericValue(0));
                    dispatch(changeRefreshContentStatus());
                    handleActiveToast({message: t(`feedbackComplete`)});
                } else {
                    handleActiveError({message: t(`error`), description: t(`contentStatus`)});
                }
            } else {
                handleActiveToast({message: t(`error`)});
            }
        }
    };

    const handleSaveFeedback = async () => {
        if (window.confirm(t(`confirmSave`))) {
            const response = await updateServiceRequestForFeedback(feedbackData);
            if (response && response.status === 200) {
                dispatch(changeRefreshContentStatus());
                handleActiveToast({message: t(`saved`)});
            } else {
                handleActiveError({message: t(`error`)});
            }
        }
    };

    const handleUpdateFeedback = async (value, target) => {
        const data = {...feedbackData, modification: true, [target]: value};
        const response = await updateServiceRequestForFeedback(data);
        if (response && response.status === 200) {
            setFeedbackData((prev) => ({...prev, [target]: value}));
            handleActiveToast({message: t(`updated`)});
        } else {
            handleActiveError({message: t(`error`)});
        }
    };

    const showComponent = () => {
        return serviceRequest.feedbackUserId
            || statusNumericValue === ContentStatus.FEEDBACK.statusNumericValue;
    };

    const showFeedbackInput = () => {
        return serviceRequest.rudAuthDto.update;
    };

    return (
        <>
            {serviceRequest.feedbackCloseDate && showComponent() && (
                <DetailPanel title={"만족도 관리"}>
                    <DetailKvTable>
                        <tbody>
                        {statusNumericValue > ContentStatus.FEEDBACK.statusNumericValue && (
                            <>
                                <tr>
                                    <Th_title title={"만족도 완료일"} className="fieldset-td" colspan={3}>
                                        <div>{serviceRequest.feedbackCloseDate}</div>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"만족도 조사자"} className="fieldset-td" colspan={3}>
                                        <div>{serviceRequest.feedbackCloseUser?.name}</div>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"만족도"} className="fieldset-td" colspan={3}>
                                        <RatedStart defaultValue={serviceRequest.feedbackRating}/>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"만족도 내용"} className="fieldset-td" colspan={3}>
                                        <div>{serviceRequest.feedbackDescription}</div>
                                    </Th_title>
                                </tr>
                            </>
                        )}
                        </tbody>
                    </DetailKvTable>
                </DetailPanel>
            )}

            {!serviceRequest.feedbackCloseDate && showFeedbackInput()
                && statusNumericValue === ContentStatus.FEEDBACK.statusNumericValue && (
                <DetailPanel title={"만족도 관리"}>
                    <DetailKvTable>
                        <tbody>
                        <tr>
                            <Th_title title={"만족도"} className="fieldset-td" colspan={3} required={true}>
                                <FeedbackToolbar>
                                    {serviceRequest.feedbackUserId ? (
                                        <ServiceStarRating
                                            target={"feedbackRating"}
                                            setData={setFeedbackData}
                                            defaultValue={serviceRequest.feedbackRating}
                                            callback={handleUpdateFeedback}
                                        />
                                    ) : (
                                        <ServiceStarRating
                                            target={"feedbackRating"}
                                            setData={setFeedbackData}
                                            defaultValue={3}
                                        />
                                    )}
                                    <FeedbackActions>
                                        {!serviceRequest.feedbackUserId && (
                                            <button
                                                type="button"
                                                className="service-feedback-btn"
                                                onClick={handleSaveFeedback}
                                            >
                                                만족도 정보등록
                                            </button>
                                        )}
                                        <button
                                            type="button"
                                            className="service-feedback-btn service-feedback-btn--primary"
                                            onClick={handleChangeNextStatus}
                                        >
                                            만족도 완료
                                        </button>
                                    </FeedbackActions>
                                </FeedbackToolbar>
                            </Th_title>
                        </tr>

                        {serviceRequest.feedbackUserId ? (
                            <tr>
                                <Th_title title={"만족도 내용"} className="fieldset-td" colspan={3}>
                                    <TextAreaUpdateBasic
                                        target={"feedbackDescription"}
                                        value={feedbackData.feedbackDescription}
                                        callback={handleUpdateFeedback}
                                    />
                                </Th_title>
                            </tr>
                        ) : (
                            <tr>
                                <Th_title title={"비고"} className="fieldset-td" colspan={3}>
                                    <TextAreaBasic
                                        target={"feedbackDescription"}
                                        placeholder={"내용을 작성해주세요."}
                                        data={{data: feedbackData, setData: setFeedbackData}}
                                    />
                                </Th_title>
                            </tr>
                        )}
                        </tbody>
                    </DetailKvTable>
                </DetailPanel>
            )}
        </>
    );
};

export default ServiceRequestFeedback;
